function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.63926 0H20.3607C25.1244 0 29 3.87555 29 8.63926V20.3607C29 25.1244 25.1244 29 20.3607 29H8.63926C3.87555 29 0 25.1244 0 20.3607V8.63926C5.34058e-05 3.87555 3.8756 0 8.63926 0ZM2.9174 20.3607C2.9174 23.5208 5.47919 26.0826 8.63926 26.0826H20.3607C23.5208 26.0826 26.0826 23.5208 26.0826 20.3607V8.63926C26.0826 5.47914 23.5208 2.9174 20.3607 2.9174H8.63926C5.47919 2.9174 2.9174 5.47914 2.9174 8.63926V20.3607Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5001 6.99957C18.6358 6.99957 22.0005 10.3643 22.0005 14.4999C22.0005 18.6356 18.6358 22.0004 14.5001 22.0004C10.3643 22.0004 6.99963 18.6357 6.99963 14.4999C6.99963 10.3642 10.3643 6.99957 14.5001 6.99957ZM14.5001 19.083C17.0312 19.083 19.0831 17.0312 19.0831 14.5C19.0831 11.9688 17.0312 9.91696 14.5001 9.91696C11.9689 9.91696 9.91702 11.9688 9.91702 14.5C9.91702 17.0311 11.969 19.083 14.5001 19.083Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.98509 8.85315C5.99249 8.85315 5.18784 8.04849 5.18784 7.05589C5.18784 6.06329 5.99249 5.25863 6.98509 5.25863C7.97769 5.25863 8.78235 6.06329 8.78235 7.05589C8.78235 8.04849 7.97769 8.85315 6.98509 8.85315Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 14.5,
  y1: 28.9156,
  x2: 14.5,
  y2: 0.225248,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E09B3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#C74C4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#C21975"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7024C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 14.5001,
  y1: 28.9156,
  x2: 14.5001,
  y2: 0.225248,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E09B3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#C74C4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#C21975"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7024C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 6.98509,
  y1: 28.9156,
  x2: 6.98509,
  y2: 0.22526,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E09B3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#C74C4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#C21975"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7024C4"
})));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.efe5ffcd.svg";
export { ForwardRef as ReactComponent };